export default __webpack_public_path__ + "static/media/gnosis.8433adff.png";